import AsyncPage from './async-page'

const buttonClass = { active: 'is-white', default: 'is-grey-3' }

export default class {
  constructor() {
    const elements = document.querySelectorAll(
      '[data-component="section-filter"]'
    )

    this.initViewportObserver(elements)
  }

  initViewportObserver(elements) {
    // Create intersection observer to watch for elements entering viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target)

            this.asyncPage = new AsyncPage(entry.target).then(() => {
              this.initComponent(entry.target)
            })
          }
        })
      },
      {
        // Trigger when element is 10% visible
        threshold: 0.1,
        // Add some margin to trigger slightly before element is fully visible
        rootMargin: '50px',
      }
    )

    // Start observing all section-filter elements
    elements.forEach((element) => {
      observer.observe(element)
    })
  }

  initComponent(element) {
    const boxes = element.querySelectorAll('[data-filter]')
    const carousel = element.querySelector('.swiper')
    let active = element.querySelector('.button[data-slug].is-white')

    element.addEventListener('click', (e) => {
      const btn = e.target.closest('.button[data-slug]')

      if (btn && btn != active) {
        active.classList.remove(buttonClass.active)
        active.classList.add(buttonClass.default)

        btn.classList.remove(buttonClass.default)
        btn.classList.add(buttonClass.active)

        active = btn

        boxes.forEach((box) => {
          const tags = box.dataset.filter.split(' ')
          const slug = btn.dataset.slug

          const target = box.closest(carousel ? '.swiper-slide' : '.column')

          target.classList.toggle(
            'is-hidden',
            !tags.includes(slug) && slug.length
          )
        })

        if (carousel) carousel.swiper.update()
      }
    })
  }
}
